// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { benefitsWidgetStyles } from "@guestsupply/App/Widgets/BenefitsWidget/BenefitsWidget";
import { color, ellipsis, layoutContainer, xScreen } from "@guestsupply/XDL/Utilities";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

benefitsWidgetStyles.wrapper = {
    css: css`
        width: 100%;
        background: ${color("common.ui2")};
    `,
};

benefitsWidgetStyles.contentAndBenefitsWrapper = {
    css: css`
        padding: 32px 0;
        ${layoutContainer}
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        gap: 22px;
        ${xScreen("lte", "md")} {
            flex-direction: column;
            gap: 20px;
        }
    `,
};
benefitsWidgetStyles.contentWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        flex: 1 1 33%;
        ${xScreen("lte", "md")} {
            width: 100%;
        }
    `,
};
benefitsWidgetStyles.heading = {
    wrapper: {
        css: css`
            margin-bottom: 12px;
        `,
    },
};
benefitsWidgetStyles.subHeading = {
    as: "p",
    size: "13px",
    weight: 400,
    lineHeight: "20px",
    css: css`
        margin-bottom: 20px;
        ${TypographyStyle} {
            font-size: 13px;
            font-weight: 400;
            letter-spacing: 0;
            line-height: 20px;
            margin-bottom: 0;
        }
    `,
};
benefitsWidgetStyles.buttonsWrapper = {
    css: css`
        display: flex;
        gap: 12px;
    `,
};
benefitsWidgetStyles.secondButton = {
    variant: "tertiary",
};
benefitsWidgetStyles.benefitsGridContainer = {
    gap: 22,
    css: css`
        margin-top: auto;
    `,
};
benefitsWidgetStyles.benefitsGridItem = {
    width: [12, 12, 12, 4, 4],
};
benefitsWidgetStyles.benefitCard = {
    css: css`
        display: block;
        width: 100%;
        height: 100%;
        border-radius: 4px;
        border: 1px solid ${color("common.border")};
        background-color: ${color("common.ui1")};
        padding: 12px;
    `,
};
benefitsWidgetStyles.iconTitleWrapper = {
    css: css`
        display: flex;
        align-items: center;
        gap: 12px;
        margin-bottom: 12px;
        min-height: 32px;
    `,
};
benefitsWidgetStyles.icon = {
    css: css`
        width: 32px;
        height: 32px;
        img {
            width: 100%;
            height: auto;
            max-height: 100%;
            max-width: 100%;
        }
    `,
};
benefitsWidgetStyles.cardTitle = {
    variant: "h6",
    as: "p",
    css: css`
        color: ${color("primary.main")};
        margin-bottom: 0;
    `,
};
benefitsWidgetStyles.description = {
    as: "p",
    css: css`
        * {
            margin-bottom: 0;
            font-size: 13px;
            font-weight: 400;
            line-height: 20px;
            letter-spacing: 0;
            ${ellipsis(3)}
        }
    `,
};
